import { Component, EventEmitter, Inject, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
//import { Moment } from 'moment';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'app-cal-component',
  templateUrl: './cal-component.component.html',
  styleUrls: ['./cal-component.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class CalComponent implements OnInit {
  @Input() required: boolean = false;
  @Input('selectedDate') selectedDate: Moment;
  @ViewChild('calendar', {static: true}) calendar!: MatCalendar<moment.Moment>;
  @Output()  dateSelected: EventEmitter<moment.Moment> = new EventEmitter();


  constructor(@Inject(MAT_DIALOG_DATA) public calData: any, private renderer: Renderer2, public dialogRef: MatDialogRef<CalComponent>
  ) { 

  }

  ngOnInit(): void {
    if (this.calData.selectedDate)
    {
      console.log("incoming selected date:" + this.calData.selectedDate);
      this.selectedDate = this.calData.selectedDate;
      this.calendar.activeDate = this.selectedDate;
      
    }
  }

  customCalClick(evt: Event)
  {
    console.log("captured click:" + evt)
    
  }

  customCalBtnClick(evt: Event)
  {
    console.log("captured click:" + evt)
  }

  dateChanged(evt: Event)
  {
    console.log("selected date change :" + evt)
    
    // this.dateSelected.emit(this.selectedDate);
    this.dialogRef.close();
  }

}
